import { Box, Text } from '@quintoandar-tokko/jopijs';
import EventParticipantTag from '../../PendingEvents/PendingEventCard/EventParticipant/EventParticipantTag';
import ProfilePicture from '../../ProfilePicture';
import LeadsAccountIndicator from './LeadsAccountIndicator';
import style from './pendingLeadsCard.module.scss';
import { getAgentCardData } from '../../utils';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

function MultipleEntityCard({ lead, type, trackCallback = null }) {
  const agentData = getAgentCardData({
    id: lead.agent_id,
    name: lead.agent_name,
    profile_picture_url: lead.profile_picture_url,
  });

  const handleClickCard = () => {
    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.ROW);
    }
  };

  return (
    <Box className={style.pendingLeadsCard} onClick={handleClickCard}>
      {type === 'agent' ? (
        <Box className={style.leftContentContainer}>
          <ProfilePicture
            alt="Agent profile picture"
            src={agentData.profilePicture}
            type="agent"
          />
          <EventParticipantTag
            participants={[agentData]}
            agentDataParsed
            type="agent"
            mainAgentTag
            trackCallback={trackCallback}
          />
        </Box>
      ) : (
        <Box className={style.leftContentContainer}>
          <ProfilePicture
            type="branch"
            alt="Branch Logo"
            src={lead.branch_logo_url}
          />
          <Text className={style.branchName}>{lead.branch_name}</Text>
        </Box>
      )}
      <Box className={style.rightContentContainer}>
        <LeadsAccountIndicator count={lead.count} />
      </Box>
    </Box>
  );
}

export default MultipleEntityCard;
